import { adminApi, advertiserApi } from '@client/auth';

/* Advertiser Portal */

export function fetchCampaigns() {
  return advertiserApi.get('/campaigns');
}

export function fetchCampaignParticipants(campaignId) {
  return advertiserApi.get(`/campaigns/${campaignId}/profiles/shortlist`);
}

export function fetchFollwersStats(campaignId, influencersData) {
  return advertiserApi.get(
    `/campaigns/${campaignId}/influencers/follower-statistics?influenserIds=${influencersData.influenserIds.join(
      ','
    )}`
  );
}

export function fetchApprovedProfiles(campaignId) {
  return advertiserApi.get(`/campaigns/${campaignId}/profiles/approved`);
}

export function fetchDraftDetails(campaignId) {
  return advertiserApi.get(`/campaigns/${campaignId}/draft`);
}

export function fetchParticipants(campaignId, influencerId) {
  return advertiserApi.get(`/campaigns/${campaignId}/media/${influencerId}`);
}

export function updateParticipantMediaFeedback(campaignId, media) {
  return advertiserApi.post(`/campaigns/${campaignId}/media/feedback`, media);
}

export function fetchContactInfo(campaignId) {
  return advertiserApi.get(`/campaigns/${campaignId}/profiles-csv`, {
    responseType: 'arraybuffer',
    timeout: 0,
  });
}

export function acceptAndRejectCampaignParticipants(
  campaignId,
  participantsList
) {
  return advertiserApi.put(
    `/campaigns/${campaignId}/profiles/shortlist`,
    participantsList
  );
}

export function fetchCampaignBrief(campaignId) {
  return advertiserApi.get(`/campaigns/${campaignId}/brief`);
}

export function fetchPublishedData(campaignId) {
  return advertiserApi.get(`/campaigns/${campaignId}/media/published`);
}

export function putInfluencersShipment(campaignId, influencers) {
  return advertiserApi.put(
    `/campaigns/${campaignId}/influencers/shipment-sent`,
    { influencers }
  );
}

export function donwloadOriginalContend(downloadUrl) {
  return advertiserApi.get(`/${downloadUrl}`);
}

/* Admin Portal: managing advertisers */

export function fetchAdvertisers(queryParams = '') {
  return adminApi.get(`/advertisers${queryParams}`);
}

export function fetchAdvertiser(advertiserId = '') {
  return adminApi.get(`/advertisers/${advertiserId}`);
}

export function postAdvertiser(advertiser) {
  return adminApi.post('/advertisers', advertiser);
}

export function putAdvertiser(advertiser, advertiserId) {
  return adminApi.put(`/advertisers/${advertiserId}`, advertiser);
}

export function putAdvertiserImage(advertiserId, imgFile) {
  const formData = new FormData(); // eslint-disable-line
  formData.append('file', imgFile, imgFile.name);

  return adminApi.put(`/advertisers/${advertiserId}/image`, formData);
}

export function deleteAdvertiser(advertiserId) {
  return adminApi.delete(`/advertisers/${advertiserId}`);
}

export function inviteAdvertiser(email, advertiserId) {
  return adminApi.post(`/advertisers/${advertiserId}/users`, { email });
}

export function deleteAdvertiserUser(advertiserId, email) {
  return adminApi.delete(`/advertisers/${advertiserId}/users/${email}`);
}
